import { useSidebar } from "../components/SidebarContext";
import { Menu } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import { useSidebarItems } from "../components/data/sidebarData";
import logo from "../assets/img/logo.png";
import "./SideBar.css";
import decodeJWT from "./services/decodeJWT";
import SessionManager from "./auth/sessionmanager";

function SideBar() {
  const navigate = useNavigate();
  const location = useLocation();
  const items = useSidebarItems();
  const { openKeys, setOpenKeys } = useSidebar();

  // Decode the token and extract the role properly
  const role = decodeJWT(SessionManager.getToken());

  // Route mapping for correct sidebar selection
  const routeMapping = {
    "/home": { selected: "main-0", open: [] },
    "/Requesthistory": { selected: "main-1", open: [] },
    "/Solver_Marketplace": { selected: "2.1", open: ["main-2"] },
    "/SolvingProcesses_Marketplace": { selected: "2.2", open: ["main-2"] },
    "/Results": { selected: "main-2", open: ["main-2"] },
    "/WizardSolvingProcesses": { selected: "main-3", open: [] },
    "/WorkflowEngine": { selected: "main-4", open: [] },
    "/CreateNewEndpoints": { selected: "5.1", open: ["main-5"] },
    "/OnboardingSolvingProcesses": { selected: "5.2", open: ["main-5"] },
    "/SolverIframe": { selected: "main-", open: [] },
  };

  const mapping = routeMapping[location.pathname] || { selected: "main-0", open: [] };

  const onMenuClick = (e) => {
    navigateToPage(e.key);
  };

  const onOpenChange = (keys) => {
    setOpenKeys(keys);
  };

  const navigateToPage = (key) => {
    const pathMap = {
      "main-0": "/home",
      "main-1": "/Requesthistory",
      "2.1": "/Solver_Marketplace",
      "2.2": "/SolvingProcesses_Marketplace",
      "main-3": "/WizardSolvingProcesses",
      "main-4": "/WorkflowEngine",
      "5.1": "/CreateNewEndpoints",
      "5.2": "/OnboardingSolvingProcesses"
    };
    navigate(pathMap[key] || "/");
    // if (key === "main-4") {
    //   window.open(pathMap[key], "_blank");
    // } else {
    //   navigate(pathMap[key] || "/");
    // }
  };

  // **Filter out "main-4" (Workflow Engine) if user is not a developer**
  const filteredItems = items.filter((item) => {
    if ( (item.key === "main-4" || item.key === "main-5") && role !== "developer") {
      return false; // Remove item if role is not "developer"
    }
    return true;
  });

  return (
    <div>
      <div style={{ height: "100%", padding: 20, borderBottomRightRadius: 10 }}>
        <img
          src={logo}
          alt="logo"
          onClick={() => navigate("/home")}
          className="logoSidebar"
          style={{ cursor: "pointer" }}
        />
      </div>
      <Menu
        selectedKeys={[mapping.selected]}
        openKeys={openKeys}
        onOpenChange={onOpenChange}
        onClick={onMenuClick}
        mode="inline"
        theme="dark"
        items={filteredItems} // Use filtered items
      />
    </div>
  );
}

export default SideBar;
